// Engelsk oversættelse af Digitalisering: dansk tekst -> engelsk. Se index.js og I18N.md.
// Hver tekst, der står i t("...") eller T("...") i koden, SKAL stå her (npm run i18n:check).
import help from "./en/help.js";
import reports from "./en/reports.js";
import tools from "./en/tools.js";
import ui from "./en/ui.js";

export default {...ui, ...tools, ...reports, ...help};
